import { render, staticRenderFns } from "./DropdownLoader.vue?vue&type=template&id=3b2f81fa&scoped=true"
import script from "./DropdownLoader.vue?vue&type=script&lang=js"
export * from "./DropdownLoader.vue?vue&type=script&lang=js"
import style0 from "./DropdownLoader.vue?vue&type=style&index=0&id=3b2f81fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2f81fa",
  null
  
)

export default component.exports